import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { useOrganization } from "../OrganizationContext"
import { supabase } from "../supabaseClient"
import { sanitizeUserTextInput } from "../utils/security"
import { ORGANIZATION_TYPES } from "../utils/organizationProfile"

function Onboarding() {
  const { organizations, refreshOrganizations, selectedOrgId } = useOrganization()
  const [name, setName] = useState("")
  const [organizationType, setOrganizationType] = useState(
    ORGANIZATION_TYPES.AUTOMOTIVE,
  )
  const [validationError, setValidationError] = useState("")
  const [rpcError, setRpcError] = useState("")
  const [isSubmitting, setIsSubmitting] = useState(false)
  const navigate = useNavigate()

  useEffect(() => {
    if (organizations.length > 0 && selectedOrgId) {
      navigate("/dashboard", { replace: true })
    }
  }, [organizations, selectedOrgId, navigate])

  const handleSubmit = async (event) => {
    event.preventDefault()
    setValidationError("")
    setRpcError("")

    const { sanitized, error } = sanitizeUserTextInput(name)
    if (!sanitized) {
      if (error) setValidationError(error)
      return
    }

    setIsSubmitting(true)
    try {
      const { error: rpcErr } = await supabase.rpc("create_org_with_admin", {
        org_name: sanitized,
        org_type: organizationType,
      })
      if (rpcErr) {
        setRpcError(rpcErr.message || "Unable to create organization right now.")
        return
      }
      setName("")
      await refreshOrganizations()
    } catch (err) {
      setRpcError("Unable to create organization right now.")
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <div className="page-container">
      <h1>Welcome to TuneUp</h1>
      <p>Create your first organization to continue.</p>
      <form onSubmit={handleSubmit} className="form">
        <label htmlFor="org-name">Organization name</label>
        <input
          id="org-name"
          type="text"
          value={name}
          onChange={(event) => setName(event.target.value)}
          placeholder="e.g. Example Motors"
          disabled={isSubmitting}
        />
        <fieldset className="organization-dialog__type-options">
          <legend>Organization type</legend>
          <label>
            <input
              type="radio"
              name="organization-type"
              value={ORGANIZATION_TYPES.AUTOMOTIVE}
              checked={organizationType === ORGANIZATION_TYPES.AUTOMOTIVE}
              onChange={(event) => setOrganizationType(event.target.value)}
              disabled={isSubmitting}
            />
            <span>
              <strong>Automotive</strong>
              <small>Includes automotive event audits and performance reporting.</small>
            </span>
          </label>
          <label>
            <input
              type="radio"
              name="organization-type"
              value={ORGANIZATION_TYPES.STANDARD}
              checked={organizationType === ORGANIZATION_TYPES.STANDARD}
              onChange={(event) => setOrganizationType(event.target.value)}
              disabled={isSubmitting}
            />
            <span>
              <strong>Standard business</strong>
              <small>Uses configurable account audits without automotive-only rules.</small>
            </span>
          </label>
        </fieldset>
        {validationError && <p className="error">{validationError}</p>}
        {rpcError && <p className="error">{rpcError}</p>}
        <button type="submit" disabled={isSubmitting}>
          {isSubmitting ? "Creating..." : "Create organization"}
        </button>
      </form>
    </div>
  )
}

export default Onboarding
